import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import CallJoin from '../CallJoin';
import {
  isIOS,
  isAndroidChrome,
  getOpenInAppUrl,
} from '../../../helpers/serverRenderingUtils';
import { receivePageMetadata } from '../../pageMetadata';

const FACEBOOK_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/GenericRWFShare_Facebook.png';
const TWITTER_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/GenericRWFShare_Twitter.png';

const mapStateToProps = (
  { station, user },
  { location: { pathname, search } }
) => {
  const inviteCode = pathname.substring(pathname.lastIndexOf('/') + 1);
  return {
    doRequireStation: true,
    isIOS: isIOS(),
    isAndroidChrome: isAndroidChrome(),
    openInAppUrl: getOpenInAppUrl(`${pathname}${search}`),
    station,
    user,
    inviteCode,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onComponentWillMount: () => {
    dispatch(
      receivePageMetadata({
        image: FACEBOOK_SOCIAL_IMAGE,
        twitterImage: TWITTER_SOCIAL_IMAGE,
      })
    );
  },
  onPressDoneRecordingConfirmation: isUserLoggedIn => {
    if (isUserLoggedIn) {
      dispatch(push('/dashboard'));
    } else {
      dispatch(push('/signup?redirectedFrom=rwf'));
    }
  },
});

class CallJoinContainer extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.onComponentWillMount();
  }

  render() {
    return <CallJoin {...this.props} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CallJoinContainer);
